<template lang="pug">
div
  div.d-flex.align-baseline.mt-n8.w-100(v-if="!isLoading")
    v-select(
      hide-details,
      :disabled="isLoading",
      :items="devices",
      item-text="label",
      item-value="deviceId",
      placeholder="Select device",
      v-model="activeCameraId",
      @change="updateActiveCamera",
    )
    v-btn.ml-2(
      fab,
      x-small,
      depressed,
      color="primary",
      @click="close",
    )
      v-icon fas fa-times

  div.text-center.my-10(v-if="isLoading")
    v-progress-circular(
      indeterminate,
      :value="40",
    )
  div(v-if="showScanner && !isLoading")
    video.video(ref="video")
      canvas(style='display: none' ref='canva')
    div.text-center
      v-btn.mt-n10(
        fab,
        depressed,
        color="primary",
        @click="takePicture",
      )
        v-icon fas fa-camera
</template>

<script>
import { mapGetters } from 'vuex';
import { dateURItoFile } from '@/utils/helper';

export default {
  props: {
    devices: {
      type: Array,
      required: true,
    },
  },

  data: () => ({
    activeCameraId: null,
    counter: 0,
    mediaStream: null,
    showScanner: false,
    isLoading: true,
  }),

  computed: {
    ...mapGetters({
      activeCamera: 'auth/activeCamera',
    }),
  },

  beforeDestroy() {
    window.removeEventListener('keydown', this.takePictureViaSpaceKey);
    this.close();
  },

  mounted() {
    window.addEventListener('keydown', this.takePictureViaSpaceKey);
    this.updateActiveCamera(this.activeCamera);
  },

  methods: {
    takePictureViaSpaceKey(event) {
      if (event.code === 'Space' && !this.isLoading) {
        event.preventDefault();
        this.takePicture();
      }
    },

    async close() {
      if (this.mediaStream) {
        const tracks = this.mediaStream.getVideoTracks();
        tracks.forEach(track => {
          track.stop();
        });
        this.mediaStream = null;
      }
      this.$emit('hideScanner');
    },

    takePicture() {
      const canva = this.$refs.canva;
      const video = this.$refs.video;
      canva.width = video.videoWidth;
      canva.height = video.videoHeight;

      const ctx = canva.getContext('2d');
      ctx.save();
      ctx.drawImage(video, 0, 0);
      ctx.restore();

      this.$emit('scan', dateURItoFile(canva.toDataURL('image/png')));
      this.close();
    },

    updateActiveCamera(id) {
      this.$store.dispatch('auth/updateActiveCamera', id);

      if (this.mediaStream) {
        const tracks = this.mediaStream.getVideoTracks();
        tracks.forEach(track => {
          track.stop();
        });
      }

      navigator.mediaDevices
        .getUserMedia({ video: { deviceId: { exact: this.activeCamera } } })
        .then(stream => {
          this.activeCameraId = this.activeCamera;
          this.showScanner = true;
          this.isLoading = false;
          this.$nextTick(() => {
            this.mediaStream = stream;
            const video = this.$refs.video;
            video.srcObject = this.mediaStream;
            video.play();
          });
        });
    },
  },
};
</script>

<style scoped>
.video {
  width: 100%;
  margin-top: 32px;
}
</style>
